/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} This_Page_Is_Private_Do_Not_SInputs */

const en_this_page_is_private_do_not_s = /** @type {(inputs: This_Page_Is_Private_Do_Not_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This page is private. Do not share the URL, it's tied to your purchase.`)
};

const es_this_page_is_private_do_not_s = /** @type {(inputs: This_Page_Is_Private_Do_Not_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta página es privada. No compartas la URL — está vinculada a tu compra.`)
};

const fr_this_page_is_private_do_not_s = /** @type {(inputs: This_Page_Is_Private_Do_Not_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette page est privée. Ne partagez pas l'URL — elle est liée à votre achat.`)
};

const de_this_page_is_private_do_not_s = /** @type {(inputs: This_Page_Is_Private_Do_Not_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Seite ist privat. Teile die URL nicht — sie ist mit deinem Kauf verknüpft.`)
};

const ja_this_page_is_private_do_not_s = /** @type {(inputs: This_Page_Is_Private_Do_Not_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このページはプライベートです。URLを共有しないでください — 購入に紐付けられています。`)
};

const zh_this_page_is_private_do_not_s = /** @type {(inputs: This_Page_Is_Private_Do_Not_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此页面是私密的。请勿分享此 URL — 它与您的购买绑定。`)
};

const ar_this_page_is_private_do_not_s = /** @type {(inputs: This_Page_Is_Private_Do_Not_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هذه الصفحة خاصة. لا تشارك الرابط — إنه مرتبط بعملية الشراء الخاصة بك.`)
};

const id_this_page_is_private_do_not_s = /** @type {(inputs: This_Page_Is_Private_Do_Not_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman ini bersifat pribadi. Jangan bagikan URL-nya — tautan ini terkait dengan pembelian Anda.`)
};

const it_this_page_is_private_do_not_s = /** @type {(inputs: This_Page_Is_Private_Do_Not_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa pagina è privata. Non condividere l'URL — è legato al tuo acquisto.`)
};

const ru_this_page_is_private_do_not_s = /** @type {(inputs: This_Page_Is_Private_Do_Not_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эта страница приватна. Не делитесь URL-адресом — он привязан к вашей покупке.`)
};

const pt_this_page_is_private_do_not_s = /** @type {(inputs: This_Page_Is_Private_Do_Not_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta página é privada. Não compartilhe a URL — ela está vinculada à sua compra.`)
};

const ko_this_page_is_private_do_not_s = /** @type {(inputs: This_Page_Is_Private_Do_Not_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 페이지는 비공개입니다. URL을 공유하지 마세요 — 고객님의 구매와 연동되어 있습니다.`)
};

/**
* | output |
* | --- |
* | "This page is private. Do not share the URL, it's tied to your purchase." |
*
* @param {This_Page_Is_Private_Do_Not_SInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const this_page_is_private_do_not_s = /** @type {((inputs?: This_Page_Is_Private_Do_Not_SInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<This_Page_Is_Private_Do_Not_SInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_this_page_is_private_do_not_s(inputs)
	if (locale === "es") return es_this_page_is_private_do_not_s(inputs)
	if (locale === "fr") return fr_this_page_is_private_do_not_s(inputs)
	if (locale === "de") return de_this_page_is_private_do_not_s(inputs)
	if (locale === "ja") return ja_this_page_is_private_do_not_s(inputs)
	if (locale === "zh") return zh_this_page_is_private_do_not_s(inputs)
	if (locale === "ar") return ar_this_page_is_private_do_not_s(inputs)
	if (locale === "id") return id_this_page_is_private_do_not_s(inputs)
	if (locale === "it") return it_this_page_is_private_do_not_s(inputs)
	if (locale === "ru") return ru_this_page_is_private_do_not_s(inputs)
	if (locale === "pt") return pt_this_page_is_private_do_not_s(inputs)
	return ko_this_page_is_private_do_not_s(inputs)
});